"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Wrapper = exports.StyledCircularProgress = exports.StyledButton = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _material = require("@mui/material");

var _Button = _interopRequireDefault(require("../Button"));

var _excluded = ["loading", "disabled"];

var _templateObject, _templateObject2, _templateObject3;

/* istanbul ignore next */
var StyledCircularProgress = (0, _styledComponents.default)(_material.CircularProgress)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  position: absolute;\n  top: 20%;\n  left: 49%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.main;
});
exports.StyledCircularProgress = StyledCircularProgress;

var Wrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  height: 40px;\n"])));
/* istanbul ignore next */


exports.Wrapper = Wrapper;
var StyledButton = (0, _styledComponents.default)(_Button.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\nbackground-color: ", ";\nwidth: 100%;\n&:hover {\n  background-color: ", ";\n}\n&.Mui-disabled{\n  opacity: 0.4;\n}\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.primary.main;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.primary.dark;
});
exports.StyledButton = StyledButton;

var SACDButtonWithSpinner = function SACDButtonWithSpinner(_ref4) {
  var loading = _ref4.loading,
      disabled = _ref4.disabled,
      rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(StyledButton, Object.assign({}, rest, {
    disabled: !!loading || disabled
  })), loading && /*#__PURE__*/_react.default.createElement(StyledCircularProgress, {
    size: 24
  }));
};

SACDButtonWithSpinner.defaultProps = {
  loading: false,
  disabled: false
};
var _default = SACDButtonWithSpinner;
exports.default = _default;